export default {
  unknow: 'Unknow',
  rsvp: 'Rsvp',
  event: 'Event',
  gallery: 'Gallery',
  additionalPage: 'AdditionalPage',
  saveDate: 'SaveDate',
  sender: 'Sender',
  gks: 'GKS',
  bingo: 'Bingo',
  videoGallery: 'VideoGallery',
};
